import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExportLogsService {
  private logsOutgoingIps: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([
    '37.59.251.192/29',
    '152.228.196.160/28',
    '57.130.5.96/28',
  ]);
  constructor() {}
  setLogsOutgoingIps(newIps: string[]) {
    this.logsOutgoingIps.next(newIps);
  }
  getLogsOutgoingIps() {
    this.logsOutgoingIps.getValue();
  }
  getLogsOutgoingIpsAsObservable() {
    return this.logsOutgoingIps.asObservable();
  }
}
